import { Component } from '@angular/core';
import { LanguageService } from './core/services/language.service';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

declare var gtag: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor(
    private router: Router,
    private langService: LanguageService
  ){
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        gtag('event', 'page_view', {
          page_path: event.urlAfterRedirects,
          page_title: document.title,
        });
      });
    let lang = localStorage.getItem('lang')
    if(lang){
      langService.setLanguage(lang)
    }
  }
  
  title = 'nazox';
  
}
